var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 39.999
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "download_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#78d887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78d887"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#download_svg__a)",
    d: "M-1969.5 40.5a19.87 19.87 0 01-14.142-5.858A19.868 19.868 0 01-1989.5 20.5a19.868 19.868 0 015.858-14.142A19.87 19.87 0 01-1969.5.5a19.869 19.869 0 0114.142 5.858A19.869 19.869 0 01-1949.5 20.5a19.869 19.869 0 01-5.858 14.142A19.869 19.869 0 01-1969.5 40.5zm-10.213-18.973l10.116 10.037 10.31-10.037h-5.836v-8.686h-8.754v8.686h-5.836z",
    transform: "translate(1989.5 -.5)"
  })));
}
export default SvgDownload;